import { render, staticRenderFns } from "./ProdutividadePeriodo.vue?vue&type=template&id=109b4860&"
import script from "./ProdutividadePeriodo.vue?vue&type=script&lang=js&"
export * from "./ProdutividadePeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports